export default __webpack_public_path__ + "static/media/icon-group-2.3.6171249c.png";